// @flow

import { startsWith } from 'lodash';

import splitUrl from './splitUrl';

/**
 * Remove the `from_url` query parameter from a url. Useful if you're adding a
 * from_url so it doesn't keep appending.
 */
export default (href: string): string => {
  if (!href || href.indexOf('?') < 0) {
    return href;
  }
  const { baseHref, queryString } = splitUrl(href);
  const queryStringParts = queryString.split('&');
  const cleanQueryStringParts = queryStringParts.filter(
    part => !startsWith(part, 'from_url=')
  );
  const cleanQueryString = cleanQueryStringParts.join('&');
  if (cleanQueryString === '') {
    return baseHref;
  }
  return `${baseHref}?${cleanQueryString}`;
};
